/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetOfferFromHistoryWebRequest,
  TGetOfferFromHistoryWebModel,
  IMappers,
  TGetOfferFromHistoryWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferFromHistoryResponseV2 } from '../../entities/offer_from_history/OfferFromHistoryResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOfferFromHistoryWebModel(
  parameters: IGetOfferFromHistoryWebRequest,
): TGetOfferFromHistoryWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v2/get-offer-from-history-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetOfferFromHistoryWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferFromHistoryWebRequest;
}

export async function fetchGetOfferFromHistoryWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferFromHistoryWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOfferFromHistoryWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOfferFromHistoryWebModel(parameters),
    config,
  )) as FetchResponse<TGetOfferFromHistoryWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferFromHistoryResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOfferFromHistoryWebResponse>;
}
